import styled from "styled-components";
import Colors from "infrastructure/utils/colors";

export const Panel = styled.div<{ $rtl: boolean }>`
  display: flex;
  flex-direction: column;
  width: 392px;
  max-height: 480px;
  margin: -12px;
  direction: ${(p) => (p.$rtl ? "rtl" : "ltr")};
  text-align: ${(p) => (p.$rtl ? "right" : "left")};
`;

export const PanelHeader = styled.div`
  display: flex;
  flex-direction: row;
  align-items: flex-start;
  justify-content: space-between;
  gap: 12px;
  padding: 16px 16px 12px;
  flex-shrink: 0;
`;

export const TitleBlock = styled.div`
  display: flex;
  flex-direction: column;
  gap: 4px;
  min-width: 0;
`;

export const PanelTitle = styled.h5`
  margin: 0;
  font-family: Famtree, sans-serif;
  font-size: 16px;
  font-weight: 700;
  line-height: 1.3;
  color: ${Colors.charcoal_grey};
`;

export const UnreadSummary = styled.span`
  font-family: Famtree, sans-serif;
  font-size: 12px;
  line-height: 1.4;
  color: ${Colors.charcoal_grey_54};
`;

export const MarkAllReadButton = styled.button`
  display: inline-flex;
  flex-direction: row-reverse;
  align-items: center;
  gap: 6px;
  padding: 0;
  margin: 0;
  border: none;
  background: transparent;
  cursor: pointer;
  font-family: Famtree, sans-serif;
  font-size: 12px;
  color: ${Colors.charcoal_grey};
  white-space: nowrap;
  flex-shrink: 0;

  &:hover:not(:disabled) {
    color: ${Colors.black};
  }

  &:disabled {
    cursor: default;
    opacity: 0.45;
  }
`;

export const DottedDivider = styled.div`
  flex-shrink: 0;
  margin: 0 16px;
  border-bottom: 1px dashed ${Colors.border};
`;

export const ScrollBody = styled.div`
  flex: 1;
  min-height: 0;
  overflow-y: auto;
  padding: 12px 16px 8px;
`;

export const SectionLabel = styled.span`
  display: block;
  margin-bottom: 10px;
  font-family: Famtree, sans-serif;
  font-size: 12px;
  color: ${Colors.charcoal_grey_54};
`;

export const EmptyText = styled.span`
  display: block;
  padding: 8px 0 12px;
  font-family: Famtree, sans-serif;
  font-size: 13px;
  color: ${Colors.charcoal_grey_54};
`;

export const PanelFooter = styled.div`
  flex-shrink: 0;
  padding: 12px 16px 16px;
  border-top: 1px solid ${Colors.border};
  background: ${Colors.white};
`;

export const DisplayAllButton = styled.button`
  display: block;
  width: 100%;
  padding: 0;
  margin: 0;
  border: none;
  background: transparent;
  cursor: pointer;
  font-family: Famtree, sans-serif;
  font-size: 15px;
  font-weight: 700;
  color: ${Colors.green};
  text-align: center;

  &:hover {
    color: ${Colors.cool_green};
  }
`;

export const PopoverCard = styled.div`
  display: flex;
  flex-direction: row-reverse;
  align-items: flex-start;
  gap: 12px;
  padding: 12px 14px;
  margin-bottom: 10px;
  border-radius: 12px;
  border: 1px solid ${Colors.border};
  background: ${Colors.white};
`;

export const PopoverCardIcon = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  width: 40px;
  height: 40px;
  border-radius: 50%;
  background: ${Colors.green_12};
  color: ${Colors.green};
  font-size: 18px;
  flex-shrink: 0;
`;

export const PopoverCardBody = styled.div<{ $rtl: boolean }>`
  flex: 1;
  min-width: 0;
  text-align: ${(p) => (p.$rtl ? "right" : "left")};
`;

export const PopoverCardTitle = styled.p`
  margin: 0 0 4px;
  font-family: Famtree, sans-serif;
  font-size: 14px;
  font-weight: 700;
  line-height: 1.35;
  color: ${Colors.charcoal_grey};
`;

export const PopoverCardDescription = styled.p`
  margin: 0;
  font-family: Famtree, sans-serif;
  font-size: 12px;
  line-height: 1.45;
  color: ${Colors.charcoal_grey_54};
`;

export const BellTrigger = styled.span`
  display: inline-flex;
  align-items: center;
  justify-content: center;
  width: 40px;
  height: 40px;
  border-radius: 12px;
  border: 1px solid ${Colors.border};
  background: transparent;
  cursor: pointer;
  transition: border-color 0.2s ease;

  &:hover {
    border-color: ${Colors.light_gray};
  }

  .anticon {
    font-size: 18px;
    color: ${Colors.green};
  }
`;
